import { Box } from '@chakra-ui/react';
import { useState } from 'react';
import { getTokenLogoUrl } from 'utils/tokenLogos';

const SYMBOL_COLORS = [
  '#4A90D9', '#50C878', '#E8833A', '#9B59B6',
  '#E74C3C', '#1ABC9C', '#F39C12', '#3498DB',
  '#2ECC71', '#E67E22', '#8E44AD', '#16A085',
];

const getColorForSymbol = (symbol: string): string => {
  let hash = 0;
  for (let i = 0; i < symbol.length; i++) {
    hash = symbol.charCodeAt(i) + ((hash << 5) - hash);
  }
  return SYMBOL_COLORS[Math.abs(hash) % SYMBOL_COLORS.length];
};

interface TokenIconProps {
  symbol: string;
  size?: number;
  tokenId?: string;
}

const TokenIcon = ({ symbol, size = 28, tokenId }: TokenIconProps) => {
  const [imgFailed, setImgFailed] = useState(false);
  const logoUrl = tokenId ? getTokenLogoUrl(tokenId) : null;

  if (logoUrl && !imgFailed) {
    return (
      <Box
        w={`${size}px`}
        h={`${size}px`}
        minW={`${size}px`}
        borderRadius="full"
        overflow="hidden"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <img
          src={logoUrl}
          alt={symbol}
          width={size}
          height={size}
          style={{ objectFit: 'cover' }}
          onError={() => setImgFailed(true)}
        />
      </Box>
    );
  }

  const letter = (symbol || '?')[0].toUpperCase();
  const color = getColorForSymbol(symbol);

  return (
    <Box
      w={`${size}px`}
      h={`${size}px`}
      minW={`${size}px`}
      borderRadius="full"
      bg={color}
      display="flex"
      alignItems="center"
      justifyContent="center"
      color="white"
      fontSize={`${Math.round(size * 0.45)}px`}
      fontWeight="bold"
      lineHeight={1}
      userSelect="none"
    >
      {letter}
    </Box>
  );
};

export default TokenIcon;
